import s from './style.css';
import cn from 'classnames';
import Circle from 'components/SliceChart/Circle';
import calcPercentage from 'utils/calcAreaPercentage';
import TextWrapper from 'components/TextWrapper';

const SliceChart = ({
	data,
	copy,
	max = 50,
	totalSliceWidth = 60,
	onRight,
	inView,
	highlight,
	highlightColors
}) => {
	const normalizedData = data.map(datum => ({
		...datum,
		size: calcPercentage(datum.percentage, max)
	}));

	const singleSliceWidth = totalSliceWidth / normalizedData.length;

	return (
		<TextWrapper
			copy={copy}
			onRight={!!onRight}
			highlight={highlight}
			highlightColors={highlightColors}
		>
			<div
				className={cn({
					[s.spaced]: data.length > 2,
					[s.sideRight]: onRight
				})}
			>
				<div className={s.container}>
					<div className={cn(s.chartWrapper, { [s.hidden]: !inView })}>
						<Circle
							percentage={max}
							size={100}
							totalSliceWidth={totalSliceWidth}
							singleSliceWidth={singleSliceWidth}
							percentageInline
							onRight={onRight}
						/>
						<div>
							{normalizedData.map((circle, i) => (
								<Circle
									{...circle}
									onRight={onRight}
									num={i}
									totalSliceWidth={totalSliceWidth}
									singleSliceWidth={singleSliceWidth}
								/>
							))}
						</div>
					</div>
				</div>
			</div>
		</TextWrapper>
	);
};

export default SliceChart;



// WEBPACK FOOTER //
// ./components/SliceChart/index.js